import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	continue: {
		id: 'generics.continue',
		defaultMessage: 'Continue',
		description: 'Copy usually refers to continuing to the next screen',
	},
	logo: {
		id: 'generics.calm.logo',
		defaultMessage: 'Calm Logo',
		description: 'alt text to say it is the calm logo',
	},
	signupHeader: {
		id: 'app.sharePrimer.signup.header',
		defaultMessage: 'Create an account to unlock and listen for free.',
		description: 'Header informing the user to sign up to listen to the content',
	},
	welcome: {
		id: 'onboarding.stress.welcome.full',
		defaultMessage: 'Welcome to {Calm}',
		description: 'Heading welcoming user to flow',
	},
	unlockMessage: {
		id: 'app.sharePrimer.header',
		defaultMessage: '{name} unlocked this content for you.',
		description: 'Personalizing the shared content with the name of the sender',
	},
	unlockMessageNoName: {
		id: 'app.sharePrimer.headerNoName',
		defaultMessage: 'Your friend unlocked this content for you.',
		description: "Personalizing the shared content when we don't have the name of the sender",
	},
	upsell: {
		id: 'app.sharePrimer.upsell',
		defaultMessage: 'Listen for free and also get an extended 30-day trial of Calm Premium.',
		description: 'Offer extended for 30 day trial',
	},
	upsellNoTrial: {
		id: 'app.sharePrimer.upsell.noTrial',
		defaultMessage: 'Listen for free.',
		description: 'Explain to the user they do not have to pay for this Calm Premium session',
	},
});
